'use strict';

const constants = {};
const constantsModules = [
  require('./constants/alarms'),
  require('./constants/batteries'),
  require('./constants/brands'),
  require('./constants/bridges'),
  require('./constants/cameras'),
  require('./constants/chimes'),
  require('./constants/credentials'),
  require('./constants/datastores'),
  require('./constants/developer'),
  require('./constants/dbmappings'),
  require('./constants/devices'),
  require('./constants/doorbells'),
  require('./constants/doorpositionsensors'),
  require('./constants/entities'),
  require('./constants/enum'),
  require('./constants/events'),
  require('./constants/featureenablements'),
  require('./constants/homekit'),
  require('./constants/houses'),
  require('./constants/keypads'),
  require('./constants/locks'),
  require('./constants/logs'),
  require('./constants/manufacturing'),
  require('./constants/orchestra'),
  require('./constants/offlinekeys'),
  require('./constants/partners'),
  require('./constants/password'),
  require('./constants/lockexternalcredentials'),
  require('./constants/pins'),
  require('./constants/envs'),
  require('./constants/resources'),
  require('./constants/rules'),
  require('./constants/subscriptions'),
  require('./constants/transfer'),
  require('./constants/timers'),
  require('./constants/users'),
  require('./constants/activityfeed'),
  require('./constants/vault'),
  require('./constants/groups'),
  require('./constants/validation'),
  require('./constants/wasystems'),
  require('./constants/notifications'),
  require('./constants/houselocations'),
];

// Load constants
constantsModules.forEach(constantsModule =>
  // eslint-disable-next-line security/detect-object-injection
  Object.keys(constantsModule).forEach(key => (constants[key] = constantsModule[key]))
);

module.exports = Object.freeze(constants);
